/**
 * Below code is taken from
 * https://github.com/srfrnk/ua-device-detector/blob/master/ua-device-detector.js
 */

const reTree = {
  test: function (string: string, regex: any) {
    const that = this;

    if (typeof regex === 'string') {
      regex = new RegExp(regex);
    }

    if (regex instanceof RegExp) {
      return regex.test(string);
    } else if (regex && Array.isArray(regex.and)) {
      return regex.and.every(function (item) {
        return that.test(string, item);
      });
    } else if (regex && Array.isArray(regex.or)) {
      return regex.or.some(function (item) {
        return that.test(string, item);
      });
    } else if (regex && regex.not) {
      return !that.test(string, regex.not);
    } else {
      return false;
    }
  }
};

export const USER_AGENTS = {
  DEVICES: {
    ANDROID: 'android',
    I_PAD: 'ipad',
    IPHONE: 'iphone',
    I_POD: 'ipod',
    BLACKBERRY: 'blackberry',
    FIREFOX_OS: 'firefox-os',
    CHROME_BOOK: 'chrome-book',
    WINDOWS_PHONE: 'windows-phone',
    PS4: 'ps4',
    VITA: 'vita',
    CHROMECAST: 'chromecast',
    APPLE_TV: 'apple-tv',
    GOOGLE_TV: 'google-tv',
    UNKNOWN: 'unknown'
  },
  DEVICES_RE: {
    ANDROID: { and: [/\bAndroid\b/, { not: /Windows Phone/ }] },
    I_PAD: /\biPad\b/,
    IPHONE: { and: [/\biPhone\b/, { not: /Windows Phone/ }] },
    I_POD: /\biPod\b/,
    BLACKBERRY: /\bblackberry\b/,
    FIREFOX_OS: { and: [/\bFirefox\b/, /\bMobile\b/] },
    CHROME_BOOK: /\bCrOS\b/,
    WINDOWS_PHONE: { or: [/\bIEMobile\b/, /\bWindows Phone\b/] },
    PS4: /\bMozilla\/5.0 \(PlayStation 4\b/,
    CHROMECAST: /\bCrKey\b/,
    APPLE_TV: /^iTunes-AppleTV\/4.1$/,
    GOOGLE_TV: /\bGoogleTV\b/,
    VITA: /\bMozilla\/5.0 \(Play(S|s)tation Vita\b/
  },
  getCurrentDevice: function () {
    const re = reTree;
    const ua = navigator.userAgent || navigator.vendor;
    const deviceInfo = {
      raw: {
        userAgent: ua,
        os: {},
        browser: {},
        device: {}
      },
      device: ''
    };

    // Test the current user agent against the regex to determine current device
    deviceInfo.raw.device = Object.keys(this.DEVICES).reduce(function (obj, item) {
      obj[this.DEVICES[item]] = re.test(ua, this.DEVICES_RE[item]);
      return obj;
    }.bind(this), {});

    // Get the name of the current device
    deviceInfo.device = [
      this.DEVICES.ANDROID,
      this.DEVICES.I_PAD,
      this.DEVICES.IPHONE,
      this.DEVICES.I_POD,
      this.DEVICES.BLACKBERRY,
      this.DEVICES.FIREFOX_OS,
      this.DEVICES.CHROME_BOOK,
      this.DEVICES.WINDOWS_PHONE,
      this.DEVICES.PS4,
      this.DEVICES.CHROMECAST,
      this.DEVICES.APPLE_TV,
      this.DEVICES.GOOGLE_TV,
      this.DEVICES.VITA
    ].reduce(function (previousValue, currentValue) {
      return (previousValue === this.DEVICES.UNKNOWN && deviceInfo.raw.device[currentValue]) ? currentValue : previousValue;
    }.bind(this), this.DEVICES.UNKNOWN);

    // Determine if Mobile, Tablet or Desktop device type was returned

    // true if mobile
    const isMobile = function () {
      return [
        this.DEVICES.ANDROID,
        // this.DEVICES.I_PAD, removing ipad from here...
        this.DEVICES.IPHONE,
        this.DEVICES.I_POD,
        this.DEVICES.BLACKBERRY,
        this.DEVICES.FIREFOX_OS,
        this.DEVICES.WINDOWS_PHONE,
        this.DEVICES.VITA
      ].some(function (item) {
        // tslint:disable-next-line:triple-equals
        return deviceInfo.device == item;
      });
    }.bind(this);

    // true if tablet
    const isTablet = function () {
      return [
        this.DEVICES.I_PAD,
        this.DEVICES.FIREFOX_OS
      ].some(function (item) {
        // tslint:disable-next-line:triple-equals
        return deviceInfo.device == item;
      });
    }.bind(this);

    // true if desktop
    const isDesktop = function () {
      return [
        this.DEVICES.PS4,
        this.DEVICES.CHROME_BOOK,
        this.DEVICES.UNKNOWN
      ].some(function (item) {
        // tslint:disable-next-line:triple-equals
        return deviceInfo.device == item;
      });
    }.bind(this);

    if (isMobile()) {
      return 'mobile';
    } else if (isTablet()) {
      return 'tablet';
    } else if (isDesktop()) {
      return 'desktop';
    }
  }
};



// WEBPACK FOOTER //
// ./src/app/shared/datepicker/shared/user-agents.ts